module.exports = __webpack_public_path__ + "img/Philippines-3-hover.4544a1c9.jpg";